import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class UploadBankAccountTransactions {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(uuid:String|Number, first_import?:boolean, date_from?, listFilters?, otp?:string): Promise<any> {
    let args = {}
    try {
      if (first_import){
        this.frontend.changeLoadingUploadTransactions(true)
        args = { 
          uuid: uuid,
          first_import: first_import,
          date_from: date_from,
          enter_code: otp == '' ? false : true,
          otp: otp
        }
      } else {
        args = { 
          uuid: uuid,
          enter_code: otp == '' ? false : true,
          otp: otp
        }
      }
      let res = await this.dispatcher.dispatch('upload_bank_account_transactions.data', args)
      this.frontend.uploadProviderJobState = 'running';
      this.frontend.uploadProviderJobId = res.job_id
      this.frontend.dialog_first_import_gocardless = false
      this.frontend.showOTPCodeDialog = false;
      this.frontend.loadingShowOTPCodeDialog = false;
      this.frontend.changeLoadingUploadTransactions(false)
    } catch (error) {
      console.error('Error upload transactions', error)
    }
    this.frontend.dialog_first_import_gocardless = false
    this.frontend.changeLoadingUploadTransactions(false)
  }
}